import { useState } from 'react';
import { Button, Heading, Stack } from '@chakra-ui/react';
import SelectorDireccionMapa from '../selector/SelectorDireccionMapa';
import 'leaflet/dist/leaflet.css';
import { useTranslation } from 'react-i18next';

const DEFAULT_POSITION = [39.547242, 2.729266];

const FaseDestino = ({ onNext, onBack, tipoServicio, posicionInicial }) => {
  const [posicionDestino, setPosicionDestino] = useState(posicionInicial || DEFAULT_POSITION);
  const [direccionDestino, setDireccionDestino] = useState('');
  const { t } = useTranslation();

  const handleNext = () => {
    console.log('[FaseDestino] direccionDestino capturada:', direccionDestino);
    if (posicionDestino) {
      onNext({ 
        puntoDestino: posicionDestino,
        destino_direccion: direccionDestino
      });
    }
  };

  return (
    <Stack spacing={6} align="center">
      <Heading size="md">{t('destino_titulo')}</Heading>
      <Stack direction="row" spacing={4}>
        <Button onClick={onBack}>{t('boton_atras')}</Button>
        <Button colorScheme="teal" onClick={handleNext} isDisabled={!posicionDestino}>
          {t('boton_siguiente')}
        </Button>
      </Stack>
      <SelectorDireccionMapa
        alertaMensaje={t('destino_alerta')}
        area_de_validez={['/data/geojson/limites/Poly_Mallorca.geojson']}
        posicionInicial={DEFAULT_POSITION}
        posicion={posicionDestino}
        setPosicion={setPosicionDestino}
        markerIconUrl={'/assets/images/taxi-marker.png'}
        setDireccion={setDireccionDestino}
      />
    </Stack>
  );
};

export default FaseDestino;